import { createTopicSpot, createActionSpot } from "../../utils/spot-utils";

const spots = [
  createTopicSpot("content-1", "Spot_A_1", 120),
  createTopicSpot("content-2", "Spot_A_2", 120),
  createTopicSpot("content-3", "Spot_A_3", 120), // spot container is missing
  createTopicSpot("content-4", "Spot_A_4", 120),
  createTopicSpot("content-5", "Spot_A_5", 120),
  createTopicSpot("content-6", "Spot_A_6", 120),
  createTopicSpot("content-7", "Spot_A_7", 120),
  createTopicSpot("content-8", "Spot_A_8", 120),
  createTopicSpot("content-9", "Spot_A_9", 120),
  createTopicSpot("content-10", "Spot_A_10", 120),
  createTopicSpot("content-11", "Spot_A_11", 120),
  createTopicSpot("content-12", "Spot_A_12", 120),
  createTopicSpot("content-13", "Spot_A_13", 120),
  createTopicSpot("content-14", "Spot_A_14", 120),
  createTopicSpot("content-15", "Spot_A_15", 120), // spot container is missing
  createTopicSpot("content-16", "Spot_A_16", 120),
  createTopicSpot("content-A", "Spot_A_A", 120),
  createTopicSpot("content-B", "Spot_A_B", 120),
  createTopicSpot("content-C", "Spot_A_C", 120),
  createTopicSpot("content-D", "Spot_A_D", 120),
  createTopicSpot("content-E", "Spot_A_E", 120),
  createTopicSpot("content-F", "Spot_A_F", 120),
  createTopicSpot("content-G1", "Spot_A_G1", 120, "M_Spot_Service"),
  createTopicSpot("content-G2", "Spot_A_G2", 120, "M_Spot_Service"),
  createTopicSpot("content-G3-HT", "Spot_A_G3_HT", 120, "M_Spot_Service"),
  createTopicSpot("content-G3-HT4", "Spot_A_G3_HT4", 120, "M_Spot_Service"),
  createTopicSpot("content-G4", "Spot_A_G4", 120, "M_Spot_Service"),
  createTopicSpot("content-G5", "Spot_A_G5", 120, "M_Spot_Service"),
  createTopicSpot("content-H", "Spot_A_H", 120),
  createTopicSpot("content-I", "Spot_A_I", 120),
  createTopicSpot("content-J", "Spot_A_J", 120),

  // createToggleSpot("loader", [2, 1, -0.7], 0.1),
  createActionSpot("doorOpen", "Door_Trigger_L", 120),
  createActionSpot("doorOpen", "Door_Trigger_R", 120),

/*   createActionSpot("doorOpen_L", "DoorL_Trigger", 100),
  createActionSpot("doorOpen_R", "DoorR_Trigger", 100), */
];

export default spots;
